var exports = {
  "i9": "xa15a2ab7--58774f--decorations-container",
};

module.exports = exports;
